import { render } from "./ContactFriend.vue?vue&type=template&id=65f421a7&scoped=true"
import script from "./ContactFriend.vue?vue&type=script&lang=js"
export * from "./ContactFriend.vue?vue&type=script&lang=js"

import "./ContactFriend.vue?vue&type=style&index=0&id=65f421a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f421a7"]])

export default __exports__